export const name = "ST_ISCOLLECTION";
export const summary = `Checks if the total number of points, linestrings, and polygons is greater than one in a \`GEOGRAPHY\` value.`;
export const reference = `
## ST_ISCOLLECTION

Checks if the total number of points, linestrings, and polygons is greater than one in a \`GEOGRAPHY\` value.

\`\`\`
ST_ISCOLLECTION(geography_expression)
\`\`\`

### Description

Returns \`TRUE\` if the total number of points, linestrings, and polygons is greater than one.

An empty \`GEOGRAPHY\` isn't a collection.


### Return type

\`BOOL\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
